import { render } from "./ViewGroup.vue?vue&type=template&id=531cf3fc&scoped=true"
import script from "./ViewGroup.vue?vue&type=script&lang=js"
export * from "./ViewGroup.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./ViewGroup.vue?vue&type=style&index=1&id=531cf3fc&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531cf3fc"]])

export default __exports__